import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TitleBox } from '../layout/title-box';
import { messages } from '../messages';

import style from './missing-printer.module.less';
import { noop } from 'ui-components/default-props/noop';

const renderBody = () => (
  <div className={style.body}>
    <FontAwesomeIcon icon={faExclamationTriangle} />
    <div className={style['printer-warning']}>
      <FormattedMessage {...messages.missingPrinter} />
    </div>
  </div>
);

export const MissingPrinter = () => <TitleBox renderBody={renderBody} renderTitle={noop} />;
